const DETAILED_COLUMNS = [
  "channel",
  "geography",
  "product_hierarchy",
  "total_spend_percentage",
  "total_revenue_percentage",
  "total_roi_percentage",
  "total_roas",
  "total_units",
  "total_spend",
  "total_revenue",
  "total_yield",
  "ad_stock_peak",
  "ad_stock_length",
  "brand_spend_percentage",
  "brand_revenue_percentage",
  "brand_spend",
  "brand_revenue",
  "brand_roi",
  "brand_roas",
  "brand_units",
  "brand_yield",
  "category_spend_percentage",
  "category_revenue_percentage",
  "category_spend",
  "category_revenue",
  "category_roi",
  "category_roas",
  "category_units",
  "category_yield",
  "product_spend_percentage",
  "product_revenue_percentage",
  "product_spend",
  "product_revenue",
  "product_roi",
  "product_roas",
  "product_units",
  "product_yield",
  "brand_marketing_contribution_percentage",
  "brand_marketing_contribution_amount",
  "brand_marketing_units",
  "category_marketing_contribution_percentage",
  "category_marketing_contribution_amount",
  "category_marketing_units",
];

const BASIC_COLUMNS = [
  "channel",
  "geography",
  "product_hierarchy",

  "total_spend_percentage",
  "total_revenue_percentage",
  "total_roi_percentage",
  "total_roas",
  "total_units",
  "total_spend",
  "total_revenue",
  "total_yield",
  "ad_stock_peak",
  "ad_stock_length",
  "brand_marketing_contribution_percentage",
  "brand_marketing_contribution_amount",
  "brand_marketing_units",
  "category_marketing_contribution_percentage",
  "category_marketing_contribution_amount",
  "category_marketing_units",
];

const ALL_BRAND = [
  "channel",
  "geography",
  "product_hierarchy",

  "total_spend_percentage",
  "total_revenue_percentage",
  "total_roi_percentage",
  "total_roas",
  "total_units",
  "total_spend",
  "total_revenue",
  "total_yield",
  "brand_spend",
  "category_spend",
  "product_spend",
  "brand_marketing_contribution_percentage",
  "brand_marketing_contribution_amount",
  "brand_marketing_units",
  "category_marketing_contribution_percentage",
  "category_marketing_contribution_amount",
  "category_marketing_units",
];

export const COLUMN_CONFIG_MAP: Record<string, string[]> = {
  all_brand: ALL_BRAND,
  // Add more custom configurations here as needed
  // all_category: ALL_CATEGORY,
  // all_product: ALL_PRODUCT,
  // brand_brand: BRAND_BRAND,
};

export const DEFAULT_COLUMNS = {
  basic: BASIC_COLUMNS,
  detailed: DETAILED_COLUMNS,
};

export { DETAILED_COLUMNS };
